<template>
 <li class="border-bottom p2">
    <router-link v-if="!(isStudy(item)) && item.post_type === 'investigation'" :to="{ name: 'Investigation', params: { investigationSlug: item.post_name }}">
      <h3 class="caps fs-xs">{{ item.post_type }}</h3>
      <h2 class="caps mb1"><span class="red">I.{{ item.code }}</span> {{ item.post_title }}</h2>
      <div class="fs-s">
        <span class="red tabular">{{ incidentDates(item) }}</span> / <span class="red">{{ item.location_title }}</span> / <span v-html="clearNewLines(item.abstract)"></span>
      </div>
    </router-link>

    <router-link v-else-if="item.post_type === 'investigation' && isStudy(item)" :to="{ name: 'Investigation', params: { investigationSlug: item.post_name }}">
      <h3 class="caps fs-xs">Study</h3>
      <h2 class="caps mb1">{{ item.post_title }}</h2>
      <div class="fs-s">
        <span class="red tabular">{{ incidentDates(item) }}</span> / <span class="red">{{ item.location_title }}</span> / <span v-html="clearNewLines(item.abstract)"></span>
      </div>
    </router-link>

    <router-link v-else-if="item.post_type === 'exhibition'" :to="{ name: 'Exhibition', params: { slug: item.post_name }}">
      <h3 class="caps fs-xs">{{ item.post_type }}</h3>
      <h2 class="caps mb1">{{ item.post_title }}</h2>
      <div class="fs-s">
        <span class="tabular" v-html="exhibitionStatus(item) + exhibitionDates(item)"></span> / {{ item.venue }} / {{ exhibitionCategory(item) }}
      </div>
    </router-link>

    <router-link v-else-if="item.post_type === 'event'" :to="{ name: 'Events', params: { slug: item.post_name }}">
      <h3 class="caps fs-xs">{{ item.post_type }}</h3>
      <h2 class="caps mb1">{{ item.post_title }}</h2>
      <div class="fs-s">
        <span class="tabular" v-html="eventDates(item)"></span> / {{ item.venue }}
      </div>
    </router-link>

    <router-link v-else-if="item.post_type === 'publication'" :to="{ name: 'Publications', hash: `#${item.post_name}` }">
      <h3 class="caps fs-xs">{{ item.post_type }}</h3>
      <h2 class="caps">{{ item.post_title }} / <span class="red tabular">{{ item.year }}</span></h2>
      <div class="fs-s">
        <span v-html="item.citation" />
      </div>
    </router-link>

    <router-link v-else-if="item.post_type === 'news'" :to="{ name: 'News', params: { slug: item.post_name }}">
      <h3 class="caps fs-xs">{{ item.post_type }}</h3>
      <h2 class="caps">{{ item.post_title }}</h2>
      <div v-if="item.post_excerpt" v-html="item.post_excerpt" class="fs-s"></div>
    </router-link>

    <a v-else-if="item.post_type === 'press'" :href="item.link" target="_blank">
      <h3 class="caps fs-xs">{{ item.post_type }}</h3>
      <h2 class="caps">{{ item.post_title }}</h2>
      <div class="fs-s">
        <span class="red tabular">{{ item.date }}</span><span v-if="item.publication"> / <span>{{ item.publication }}</span></span>
        <div v-if="item.post_excerpt" v-html="item.post_excerpt" class="fs-s"></div>
      </div>
    </a>

    <router-link v-else-if="item.post_type === 'page'" :to="getPageLink(item)">
      <h3 class="caps fs-xs">{{ item.post_type }}</h3>
      <h2 class="caps">{{ item.post_title }}</h2>
      <div v-if="item.post_excerpt" v-html="item.post_excerpt" class="fs-s"></div>
    </router-link>

    <router-link v-else-if="item.post_type === 'person'" :to="{ name: 'Team Member', params: { 'slug': item.post_name } }">
      <h3 class="caps fs-xs">{{ item.post_type }}</h3>
      <h2 class="caps">{{ item.post_title }}</h2>
      <div class="fs-s">
        <span class="red">{{ item.details.role }}</span><span v-if="item.short_description"> / <span>{{ item.short_description }}</span></span>
      </div>
    </router-link>

    <a v-else :href="item.link" target="_blank">
      <h3 class="caps fs-xs">{{ item.post_type }}</h3>
      <h2 class="caps">{{ item.post_title }}</h2>
      <div v-if="item.post_excerpt" v-html="item.post_excerpt" class="fs-s"></div>
    </a>
  </li>
</template>

<script>
import { eventDates, incidentDates, formatDate, exhibitionCategory, exhibitionDates, exhibitionStatus, getPageLink, isStudy } from '@/utils'

export default {

  name: 'Search-Result',

  data () {
    return {
    }
  },

  props: ['item'],

  methods: {
    eventDates,
    formatDate,
    exhibitionCategory,
    exhibitionDates,
    exhibitionStatus,
    incidentDates,
    getPageLink,
    isStudy
  }
}
</script>

<style lang="css" scoped>
  li {
    min-height: var(--feed-item-min-height);
  }
  li:last-child {
    border-bottom: none;
  }
</style>
